import { ArrowLeftOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import ContactRepForm from '../../components/ContactRepForm';
import SearchBar from '../../components/SearchBar';
import UserMenu from '../../layouts/menus/UserMenu';
import React, { useState } from 'react';
import UserStore from '../../stores/UserStore';
import { useLocation } from 'react-router-dom';
import UTMQueryPreservingLink from '../../common/UTMQueryPreservingLink';
import { GAEvent } from '../../utils/tracking';
import CartIconHeader from '../../components/Cart/CartIconHeader';
import { QuoteStore } from '@/stores';
import { observer } from 'mobx-react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const HeaderLinks = observer(() => {
    const [show_contact_rep, setShowContactRep] = useState(false);
    const location = useLocation();

    const in_quote_page =
        location.pathname.includes('/rapid-quote/start') ||
        location.pathname.includes('/new-quote') ||
        location.pathname.includes('/continue');

    const in_login_page =
        location.pathname.startsWith('/login/') || location.pathname.startsWith('/rapid-quote/success');
    const is_base = location.pathname === '/';

    const renderGetQuoteButton = () => {
        if (in_quote_page) {
            return null;
        }
        if (UserStore.isAuthenticated) {
            return (
                <UTMQueryPreservingLink to={`/my-account/quotes/new-quote/`} className="ant-btn ant-btn-primary">
                    Get Quote
                </UTMQueryPreservingLink>
            );
        }
        return (
            <UTMQueryPreservingLink to={`/rapid-quote/start/`} className="ant-btn ant-btn-primary">
                Get Quote
            </UTMQueryPreservingLink>
        );
    };

    const hasRapidQuote = () => {
        return !!QuoteStore.rapidQuoteUid;
    };

    const renderLoginButton = () => {
        if (in_login_page || is_base) {
            return null;
        }
        if (!UserStore.isAuthenticated) {
            const quote_id = hasRapidQuote() ? QuoteStore.quote?.id : null;
            let next_url = `/my-account/`;
            if (quote_id) {
                next_url = `/my-account/quotes/${quote_id}/continue/`;
            }
            return (
                <UTMQueryPreservingLink
                    to={`/login?next=${encodeURIComponent(next_url)}`}
                    className="ant-btn ant-btn-default"
                    id={'header-login-button'}
                >
                    Login
                </UTMQueryPreservingLink>
            );
        }
    };

    const showConfirm = () => {
        Modal.confirm({
            title: 'Leave Customer Portal?',
            icon: <ExclamationCircleOutlined />,
            content: 'You are about to leave the portal and go back to the main website. Continue?',
            okText: 'Yes, Leave',
            cancelText: 'Stay Here',
            okButtonProps: { danger: true },
            onOk() {
                GAEvent('Button', 'Back to Website');
                window.location.href = 'https://partsbadger.com/';
            },
        });
    };

    return (
        <>
            {!UserStore.isAuthenticated ? (
                <>
                    <a onClick={showConfirm} className="d-lg-block d-none mx-2">
                        <ArrowLeftOutlined /> Back to Website
                    </a>
                </>
            ) : null}

            {UserStore.isAuthenticated && UserStore.isVerified && UserStore.hasAContact ? (
                <div className="d-lg-block d-none mr-2">
                    <SearchBar />
                </div>
            ) : null}

            {renderLoginButton()}

            {UserStore.isAuthenticated ? (
                <div
                    style={{
                        width: '100%',
                        padding: '10px 20px',
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <CartIconHeader />
                </div>
            ) : null}

            {UserStore.isAuthenticated ? (
                <UTMQueryPreservingLink to={`/my-account/support`} className="ant-btn ant-btn-default">
                    Help & Support
                </UTMQueryPreservingLink>
            ) : null}

            {UserStore.isAuthenticated ? (
                <Dropdown overlay={<UserMenu />} trigger={['click']} placement="bottomRight">
                    <Button
                        icon={<UserOutlined />}
                        block
                        data-testid="chrome-user-menu"
                        aria-label="Customer Portal user menu"
                    >
                        {UserStore.user?.default_contact?.first_name || 'Account'}
                    </Button>
                </Dropdown>
            ) : null}

            {renderGetQuoteButton()}

            {show_contact_rep && UserStore.user && (
                <ContactRepForm current_user={UserStore.user} handleClose={() => setShowContactRep(false)} />
            )}
        </>
    );
});

export default HeaderLinks;
